import React, { Component } from 'react';
import { Dropdown as SemanticDropdown } from 'semantic-ui-react';
import {masterData as masterDataAction} from '../../actions/masterdata';
import _ from 'lodash';
import {Masterdata} from '../../utility/Masterdata';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

class Dropdown extends Component {

    /**
     * isForm (Default: True) - Set to false if not going to use inside form. Otherwise, component render will return with form elements
     * defaultFetch (Default: True) - If do not want to execute action by default, set props value as 'false'. Otherwise, Execute action by default after component mount.
     * labelName (Default: '' OR empty string) - Set label name for form. This props only work on if 'isForm' props set to true
     * select: props contain the details need to set in '<select>' tag (name, data-validation-name, value...)
     * data (propType - Object or Array): props data to display in drop-down
     * queryParams: set queryParams send in API request
     * dependsOn: This component display data depends on other input value, pass other input 'Name attribute value'.
     * optionText: pass property name get from data and display in option text
     * defaultOptionText: Default option text instead 'Select placeholer'
     * defaultOptionValue: Default option value instead 'Select empty value',
     * noOption: Set false, If no option default should not display (Eg: which would display like 'Select city')
     */
    static propTypes = {
        isForm: PropTypes.bool,
        defaultFetch: PropTypes.bool,
        labelName: PropTypes.string,
        select: PropTypes.object.isRequired,
        queryParams: PropTypes.object,
        dependsOn: PropTypes.string,
        optionText: PropTypes.string.isRequired,
        optionValue: PropTypes.string.isRequired,
        action: PropTypes.func,
        defaultOptionText:PropTypes.string,
        defaultOptionValue:PropTypes.string,
        noOption:PropTypes.bool,
        data:PropTypes.any // Object, array
    }

    constructor(props){
        super(props);
        this.state = {data: []}
        this.masterdata = Masterdata.getInstance();
        this.change = this.change.bind(this);
        this.focus = this.focus.bind(this);
        this.dispatchAction = this.dispatchAction.bind(this);
        this.setData = this.setData.bind(this);
        this.updateState = this.updateState.bind(this);
        this.updateImmediateState = this.updateImmediateState.bind(this);
    }

    // Update the data state
    setData(props){
        // If data is directly passed in array format instead passing via response
        // Here set direct array data
        if(_.isArray(props.data)){
            this.setState({data:props.data});
            return;
        }
        if(_.isObject(props.data) && props.data.response !== this.props.data.response){
            // Handle the response of data
            // Check whether the props & current props data equal or not
            // If not, update the response data into current state
            this.masterdata.set(props.data);
            this.setState({data:this.masterdata.getAll()});
            return;
        }
    }
    focus(e){
        if($('.top').hasClass('triger')){
            $('.top').removeClass('triger')
        }
        $('.'+this.props.select.name).addClass('top')
        $('.'+this.props.select.name).addClass('triger');

    }
    /**
     * Update the selected value into the state
     * @param object | e
     * @param object | data
     */
    change(e, data){
        this.props.form.handleSelectChange(this.select,data.value);
        if(this.props.callback){
          this.props.callback(e, data);
        }
    }

    /**
     * Handle the dispatch action
     */
    dispatchAction(props){
        // Without define action, can not dispatch the action
        // So need to whether action is defined or not
        // If defined, dispatch it
        if(!_.isUndefined(props.action)){
            if(!props.apiCall){
                props.dispatch(props.action(props.queryParams));
            }
        }
    }

    /**
     * react state does not update the state immediately due to state process is pending state transition
     * So If any immediate update need to perform, so pass 'updateState' props with other state arguments
     *
     * Here handle update the other given state field with current state field
     *
     */
    updateImmediateState(props, immediateState, fields){
        const updateName = immediateState.name;
        const updateValue = immediateState.value || (typeof _.get(fields, updateName, "") === "string" ? "" : []);
        return _.set(fields, updateName,updateValue);
    }

    /**
     * Update the current dropdown data as empty
     *
     */
    updateState(props){

        if(this.props.form){
            this.setState({data:[]});
            const value = typeof props.select.value === "string" ? "" : [];
            const name = props.select['data-name'] || props.select.name;
            // Current state fields
            let fields = props.state.fields;

            if(!_.isUndefined(props.immediateState)){
                let immediateState = props.immediateState;
                // If immediateState is objec, convert it to array
                // Because need to push the current element also to update the state
                if(_.isPlainObject(immediateState)){
                    immediateState = [immediateState];
                }

                // Push the current element into the immediateState array
                // Because we can call setState for all the value at one time
                immediateState.push({name: name, value: value});

                // Loop through each state and update the state fields
                immediateState.forEach(immediateStateObj => {
                    fields = this.updateImmediateState(props, immediateStateObj, fields);
                });
                // Set the state..
                this.props.form.updateStateFields(fields);
            }
            else{
                this.props.form.handleSelectChange(this.select, value);
            }
        }


    }

    componentDidMount(){
        const defaultFetch = !_.isUndefined(this.props.defaultFetch) ? this.props.defaultFetch : true;
        if(defaultFetch){
            // Dispatch default action
            this.dispatchAction(this.props);
        }
        this.setData(this.props);
    }

    componentWillReceiveProps(nextProps){
        // Check whether the nextProps & current props queryParams equal or not
        // If not,dispatch the action to get data
        if(!_.isUndefined(nextProps.queryParams) && !_.isEqual(nextProps.queryParams, this.props.queryParams)){

            // If dependsOn field contains empty value, update the current state also empty and do not dispatch the action
            // return the statement. Because depends on input value empty, this input will not contain any value
            if(!_.isUndefined(nextProps.dependsOn) && !_.isUndefined(nextProps.queryParams[nextProps.dependsOn])){

                // When depends on field is empty, need to update the dependent field state also empty
                // But dependent field type might be string, array
                // So find the dependent field type,
                // If field type is string, pass empty string
                // If field type is object or array, pass empty array
                if(_.isEmpty(nextProps.queryParams[nextProps.dependsOn])){
                    this.updateState(nextProps);
                }
                else if(!_.isEmpty(this.props.queryParams[this.props.dependsOn]) && this.props.queryParams[this.props.dependsOn] !== nextProps.queryParams[nextProps.dependsOn]){
                    this.updateState(nextProps);

                    // Dispatch action with query params
                    this.dispatchAction(nextProps);
                }
                else{
                    // Dispatch action with query params
                    this.dispatchAction(nextProps);
                }
            }
            else{
                // Dispatch action with query params
                this.dispatchAction(nextProps);
            }
        }
        // Set the data
        this.setData(nextProps);

    }

    /**
     * Handle If required value is valid, return the required value. Otherwise return the default value
     */
    getValue(requiredVal, defaultVal){
        return !_.isUndefined(requiredVal) ? requiredVal : defaultVal;
    }

    render(){
        // consume the select & data props
        const {select, inputNextLine} = this.props;
        // Set lablename based on props labelName
        const labelName = this.getValue(this.props.labelName,'');
        // Set multiSelect based on props multiSelect
        const multiSelect = select['multiple'] ? select['multiple'] : false;
        // Set mandatory based on props mandatory
        const mandatory = this.getValue(this.props.mandatory, true);
        // Set isForm based on props isForm
        const isForm = this.getValue(this.props.isForm, true);

        // Set onChange based on props select onChange
        select['onChange'] = this.getValue(select['onChange'], this.change);
        // Set onClose based on props select onClose
        select['onClose'] = this.getValue(select['onClose'], ( () => { return true; } ));

        // check whether placeholer is undefined or not
        // If undefined, set lablename value as placeholder
        select['placeholder'] = this.getValue(select['placeholder'], this.props.locale.common.select +" "+`${labelName}`);

        // Set default value for options
        // When dropdown is multiSelect, then do not set default value.
        // Because the default empty became one of the option when multiple select enabled
        let options = [];
        if(this.props.noOption !== false){
            options = multiSelect ? [] : [{key:`${select.name}-option0`, value:'', text:this.props.locale.common.select +" "+`${labelName}`}];
        }
        // Map the data to options
        this.state.data.map((option) =>
            (options.push({key: option[this.props.optionValue], value: option[this.props.optionValue], text: option[this.props.optionText]})
        ));
        const  dropdown = <div className="filteritems"><SemanticDropdown
                          {...select}
                          selection
                          search
                          onFocus={this.focus}
                          options={options}
                          //loading={this.props.data.isFetching}
                          style={this.props.style}
                      /></div>

        // Form the input field required attributes
        const inputObj = {name: this.props.select.name, value: this.props.select.value}
        if(!_.isUndefined(this.props.select['data-name'])){
            inputObj['data-name'] = this.props.select['data-name'];
        }
        inputObj['data-validation-name'] = this.getValue(this.props.select['data-validation-name'], undefined);
        inputObj['data-validation-message'] = this.getValue(this.props.select['data-validation-message'], undefined);
        const  input = <input
                            ref={select => { this.select = select}}
                            type="hidden"
                            {...inputObj}
                        />

        let rendered =  <React.Fragment>{input}{dropdown}</React.Fragment>

        const validation = (mandatory && this.props.form && this.props.form.validation(select.name));
        const message = validation ? this.props.state.inputErrors[select.name].message : '';
        const classValidation = `form-group ${validation?'feild-wrong':''} ${(Array.isArray(this.props.select.value) && this.props.select.value.length) && !validation?'feild-sucess':''}`
        const valueCheck = ( (Array.isArray(this.props.select.value) && this.props.select.value.length) || this.props.select.value)?"top":'';
         const className = mandatory?classValidation:'form-group';
         const labelClass = this.props.labelClass?this.props.labelClass:'';
        // Check whether this component called inside form or not
        // If yes, then return dropdown with wrapped form element
        if(isForm){
            rendered = <div className={className}>
                            <div className="inputgroup">
                            {input}
                             <label className={labelClass+' top '+this.props.select.name} onClick={this.props.form?this.props.form.addInputLabelClass:''}>{labelName}{ mandatory  && <sup>*</sup>}</label>
                             <span className="wrong"></span>
                            <span className="sucess"></span>
                            {dropdown}
                            { inputNextLine } {/* Insert content between dropdown & error message */}
                            { mandatory && this.props.form && this.props.form.validation(select.name) &&
                            <p className="error-msg">{message}</p>}
                            </div>
                        </div>
        }
        return rendered;
    }

}

export default Dropdown;
